import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    const location = useLocation();

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-onyx-900">
                <div className="flex flex-col items-center gap-4 text-onyx-500 label-caps">
                    <div className="w-10 h-10 border-2 border-onyx-600 border-t-hellcat rounded-full animate-spin" />
                    Loading...
                </div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/marketplace" replace />;
    }
    return children;
}
